import React, { useState, useEffect } from 'react';

const CountdownOffer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 46,
    seconds: 7
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
        }
        return { hours: 23, minutes: 59, seconds: 59 };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="countdown-offer">
      <div className="container">
        <div className="offer-card">
          <div className="offer-header">
            <div className="offer-logo">
              <span className="offer-label">CURSO</span>
              <div className="offer-title">
                <span className="offer-star">✦</span>
                <span className="offer-name">Expert em Henna</span>
              </div>
            </div>
          </div>

          <div className="offer-content">
            <div className="offer-limited">
              <h3>OFERTA POR TEMPO LIMITADO!</h3>
            </div>

            <div className="offer-countdown">
              <div className="countdown-box">
                <div className="countdown-number">{String(timeLeft.hours).padStart(2, '0')}</div>
                <div className="countdown-label">H</div>
              </div>
              <div className="countdown-box">
                <div className="countdown-number">{String(timeLeft.minutes).padStart(2, '0')}</div>
                <div className="countdown-label">M</div>
              </div>
              <div className="countdown-box">
                <div className="countdown-number">{String(timeLeft.seconds).padStart(2, '0')}</div>
                <div className="countdown-label">S</div>
              </div>
            </div>

            <div className="offer-pricing">
              <div className="offer-old-price">de R$ 147,00</div>
              <div className="offer-price-label">Por Apenas</div>
              <div className="offer-installment">12X DE</div>
              <div className="offer-price-value">R$ 8,06</div>
              <div className="offer-cash">Ou apenas R$ 77,90 á vista</div>
            </div>

            <div className="offer-description">
              <p>
                Clique agora mesmo no botão abaixo e garanta sua vaga no curso. Transforme sua carreira, conquiste o sucesso e seja reconhecida como uma especialista em design de sobrancelhas. Não deixe essa oportunidade passar!
              </p>
            </div>

            <a href="https://pay.kiwify.com.br/TXv8v09" target="_blank" rel="noopener noreferrer" className="offer-cta-button">
              Sim, quero começar agora!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CountdownOffer;

